import classNames from 'classnames';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { CardBody } from 'reactstrap';

import { createForm } from '../../../../models/Form';
import { createFormField } from '../../../../models/FormField';
import { modelOf } from '../../../../prop-types';
import CheckoutStore from '../../../../store/CheckoutStore';
import FormFieldId from '../../../../types/FormFieldId';
import { labels } from '../../../../util/formLabels';
import {
  notBlank,
} from '../../../../util/formValidators';
import safeCloneDeep from '../../../../util/safeCloneDeep';
import CheckoutCountryForm from "../../recipient/CheckoutCountryForm";

const countryFormLabels = {
  [FormFieldId.DELIVERY_COUNTRY]: labels.country,
};

const CheckoutCustomerCountry = ({ checkoutStore, onOrderUpdate }) => {
  const { order } = checkoutStore;

  const form = useMemo(() => {
    const getValidators = (formField, formLabels) => {
      const validators = [];

      if (formField.required) {
        validators.push(notBlank(formLabels[formField.id]));
      }

      return validators;
    };

    const countryField = order.getShippingCustomerField(
      FormFieldId.DELIVERY_COUNTRY
    ).field;

    const countryFormFields = {};

    if (countryField) {
      const validators = getValidators(countryField, countryFormLabels);
      countryFormFields[countryField.id] = createFormField(
        safeCloneDeep(countryField),
        validators
      );
    }

    const countryForm = createForm(countryFormFields);

    return {countryForm};
  }, [
    order.getShippingCustomerField(FormFieldId.DELIVERY_COUNTRY).value,
  ]);

  const handleUpdate = ({ withoutTimer }) => {
    onOrderUpdate({ withoutTimer });
  };

  return (
    <CardBody
      className={classNames(
        'CheckoutCustomerCountry',
        'CheckoutCustomerCountry__body'
      )}
    >
      <CheckoutCountryForm
        onOrderUpdate={handleUpdate}
        countryForm={form.countryForm}
      />
    </CardBody>
  );
};

CheckoutCustomerCountry.propTypes = {
  checkoutStore: modelOf(CheckoutStore).isRequired,
  onOrderUpdate: PropTypes.func.isRequired,
};

export default inject(
  'checkoutStore',
)(observer(CheckoutCustomerCountry));
